<template>
  <transition name="toast-slide">
    <div v-if="motdStore.showToast && motdStore.currentMOTD" class="motd-toast" :class="getSeverityClass(motdStore.currentMOTD.severity)">
      <div class="motd-content">
        <!--
        <div class="motd-icon">
          <font-awesome-icon :icon="getSeverityIcon(motdStore.currentMOTD.severity)" />
        </div>
        -->
        <div class="motd-message">
          {{ motdStore.currentMOTD.message }}
        </div>
        <button @click="closeToast" class="motd-close">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { useMOTDStore } from '@/stores/motd'

const motdStore = useMOTDStore()

function closeToast() {
  // Mark as shown in localStorage
  motdStore.markAsShown()
}

function getSeverityClass(severity) {
  const classMap = {
    0: 'severity-info',
    1: 'severity-low',
    2: 'severity-medium',
    3: 'severity-high',
    4: 'severity-critical'
  }
  return classMap[severity] || 'severity-info'
}

function getSeverityIcon(severity) {
  const iconMap = {
    0: ['fas', 'info-circle'],
    1: ['fas', 'check-circle'],
    2: ['fas', 'exclamation-triangle'],
    3: ['fas', 'exclamation-circle'],
    4: ['fas', 'skull-crossbones']
  }
  return iconMap[severity] || ['fas', 'info-circle']
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

.motd-toast {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  min-width: 320px;
  background: rgba(20, 24, 32, 0.98);
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2),
              0 0 0 1px rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  overflow: hidden;
  font-family: 'Roboto', sans-serif;
}

.motd-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 12px;
}

.motd-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #6B72808C;
  align-self: flex-start;
}

.motd-message {
  flex: 1;
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.6;
  word-wrap: break-word;
  padding-right: 8px;
}

.motd-close {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-overlay-2);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  align-self: flex-start;
}

.motd-close:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: var(--text-primary);
}

/* Severity-based styling - only borders for medium and above */
.severity-medium {
  border-left: 4px solid var(--color-warning);
}

.severity-high {
  border-left: 4px solid var(--color-feed);
}

.severity-critical {
  border-left: 4px solid var(--color-error);
  animation: pulse-critical 2s ease-in-out infinite;
}

@keyframes pulse-critical {
  0%, 100% {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2),
                0 0 0 1px rgba(239, 68, 68, 0.3),
                0 0 20px rgba(239, 68, 68, 0.1);
  }
  50% {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2),
                0 0 0 1px rgba(239, 68, 68, 0.5),
                0 0 30px rgba(239, 68, 68, 0.3);
  }
}

/* Toast slide animation */
.toast-slide-enter-active {
  animation: slideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.toast-slide-leave-active {
  animation: slideOut 0.3s cubic-bezier(0.4, 0, 1, 1);
}

@keyframes slideIn {
  from {
    transform: translateX(calc(100% + 20px));
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(calc(100% + 20px));
    opacity: 0;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .motd-toast {
    top: 10px;
    right: 10px;
    left: 10px;
    max-width: none;
    min-width: 0;
  }
}
</style>
